import { Component } from '@angular/core';

@Component({
  selector: 'sp-supporting-lists-dashboard',
  templateUrl: './supporting-lists-dashboard.component.html',
  styleUrls: ['./supporting-lists-dashboard.component.scss'],
  standalone: false
})
export class SupportingListsDashboardComponent { }
